/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliInvitationListItemDto } from '../../models/amoxcalli-invitation-list-item-dto';

export interface ApiInvitationsByInstitutionInstitutionIdGet$Plain$Params {
  institutionId: string;
}

export function apiInvitationsByInstitutionInstitutionIdGet$Plain(http: HttpClient, rootUrl: string, params: ApiInvitationsByInstitutionInstitutionIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AmoxcalliInvitationListItemDto>>> {
  const rb = new RequestBuilder(rootUrl, apiInvitationsByInstitutionInstitutionIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('institutionId', params.institutionId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AmoxcalliInvitationListItemDto>>;
    })
  );
}

apiInvitationsByInstitutionInstitutionIdGet$Plain.PATH = '/api/invitations/by-institution/{institutionId}';
